import { render, staticRenderFns } from "./AddEditModule.vue?vue&type=template&id=116c8498"
import script from "./AddEditModule.vue?vue&type=script&lang=js"
export * from "./AddEditModule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports